import { UPDATE_DEEPLINK } from 'constants/actionTypes';

export const updateDeeplink = (payload: object) => ({
  type: UPDATE_DEEPLINK,
  payload,
});
